<template>
  <div>
    <el-container>
      <el-header id="header" height="80px" class="head-nav">
        <el-row>
          <el-col :span="12" class="head-log">
            <div style="float:left">
              <div class="logonKm" v-show="isLoginByKm">
                <img src="../assets/km/logonkm.png"/>
                <img src="../assets/km/logonyk.jpg"/>
              </div>
              <div class="logonNHFY" v-show="isLoginByNHFY">
                <img src="../assets/nhfy/logonnhfy.jpg"/>
              </div>
              <div class="logonSFY" v-show="isLoginBySFY">
                <img src="../assets/sfy/logo.png"/>
              </div>
              <a href="http://www.yunkanghealth.com/" target="_blank" v-show="!isLoginByKm && !isLoginByNHFY && !isLoginBySFY">
                <img src="../assets/logo.png" style="width: 74px;height: 48px"/>
              </a>
            </div>
            <div class="title">
              <div class="title-main">{{userInfo ? userInfo.org_name : ''}}</div>
              <div class="title-sub">检验报告查询</div>
            </div>
          </el-col>
          <el-col :span="12" style="padding: 0px 20px; text-align: right">
            <ul class="nav-header">
              <!--<li v-show="userInfo.is_publish == '1'">-->
              <!--<el-tooltip content="标本状态跟踪" placement="bottom-end">-->
              <!--<img src="../assets/tracker_32px.png" @click="redirectTo('/specTracker')">-->
              <!--</el-tooltip>-->
              <!--</li>-->
              <li style="cursor: pointer;" @click="redirectTo('/report')">
                <!--<el-tooltip content="报告查询" placement="bottom-end">-->
                <!--<img src="../assets/tracker_32px.png" @click="redirectTo('/report')">-->
                <!--</el-tooltip>-->
                <img src="../assets/report_32px.png"/>
                <div>
                  <span class="nav-pic-title">报告查询</span>
                </div>
              </li>
              <li>
                <el-dropdown trigger="hover">
                <span class="el-dropdown-link userinfo-inner">
                  <img src="../assets/user_64.png"/>
                  <div>
                    <span class="nav-pic-title">{{userInfo ? userInfo.user_name : ''}}</span>
                  </div>
                </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="el-icon-setting" @click.native="toOpenSysSetting">用户配置</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-key" @click.native="toOpenPwdUpdate">修改密码</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-switch-button" divided @click.native="logout">退出登录
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
            </ul>
          </el-col>
        </el-row>
      </el-header>

      <el-main v-bind:style="containerStyle">
        <router-view ref="routerMain" v-bind:myHeight="containerHeight"></router-view>
      </el-main>
    </el-container>

    <el-dialog id="dlgSysSetting" title="系统参数配置" :visible.sync="dlgSysSettingVisible" @close="onSysSettingClose">
      <sys-setting ref="sysSetting" v-on:onSaved="onSettingSaved"></sys-setting>
      <span slot="footer" class="dialog-footer" style="line-height: 40px; text-align: center; padding: 2px;">
        <el-button type="primary" size="mini" plain icon="el-icon-circle-check" @click="saveSetting">保 存</el-button>
        <el-button type="primary" size="mini" plain icon="el-icon-circle-close"
                   @click="onSysSettingClose">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog id="dlgPwdUpdate" title="修改密码" :closeOnClickModal="false" :visible.sync="dlgPwdUpdateVisible" @close="onPwdUpdateClose">
      <pwd-update ref="pwdUpdate" v-on:onPwdSaved="afterPwdSaved"></pwd-update>
      <span slot="footer" class="dialog-footer" style="line-height: 40px; text-align: center; padding: 2px;">
        <el-button type="primary" size="mini" plain icon="el-icon-circle-check" @click="savePwd">提 交</el-button>
        <el-button type="primary" size="mini" plain icon="el-icon-circle-close"
                   @click="onPwdUpdateClose">关 闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import SysSetting from '@/components/SysSetting.vue';
  import PwdUpdate from '@/components/PwdUpdate.vue';
  import {mapGetters} from 'vuex';
  import {keyCodes, resetLocalCache} from '../commons'

  export default {
    data() {
      return {
        containerHeight: 0,
        dlgSysSettingVisible: false,
        dlgPwdUpdateVisible: false,
        beforeUnloadTime: new Date().getTime()
      }
    },
    props: {},
    computed: {
      ...mapGetters(['userInfo']),
      containerStyle() {
        return {
          height: this.containerHeight + 'px',
          maxHeight: this.containerHeight + 'px',
          padding: '0px',
          overflow: 'hidden'
        }
      },
      isLoginByKm() {
        return this.$store.state.loginBy == keyCodes.LOGIN_BY_KM;
      },
      isLoginByNHFY(){
        return this.$store.state.loginBy == keyCodes.LOGIN_BY_NHFY;
      },
      isLoginBySFY(){
        return this.$store.state.loginBy == keyCodes.LOGIN_BY_SFY;
      }
    },
    components: {
      SysSetting,
      PwdUpdate
    },
    methods: {
      // getMainHeight: function () {
      //   //获取窗体主工作区域的高度
      //   return (window.innerHeight - $('#header').height());
      // },
      redirectTo(target) {
        let _this = this;
        _this.$router.push(target);
      },
      logout() {
        const _this = this;

        _this.$confirm('确定出退吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.doLogout();
        }).catch(() => {

        });
      },
      doLogout(){
        const _this = this;
        const loginBy = _this.$store.state.loginBy;
        resetLocalCache();
        if (loginBy == keyCodes.LOGIN_BY_KM) {
          _this.$router.push("/km");
        }
        else if(loginBy == keyCodes.LOGIN_BY_NHFY){
          _this.$router.push("/nhfy");
        }
        else if(loginBy == keyCodes.LOGIN_BY_SFY){
          _this.$router.push("/sfy");
        }else {
          _this.$router.push("/login");
        }
      },
      toOpenSysSetting() {
        this.dlgSysSettingVisible = true;
      },
      onSysSettingClose() {
        this.dlgSysSettingVisible = false;
      },
      saveSetting() {
        const _this = this;
        //_this.$store.dispatch('loading');
        _this.$refs.sysSetting.saveData();
      },
      onSettingSaved(){
        this.dlgSysSettingVisible = false;
      },
      toOpenPwdUpdate() {
        const _this = this;
        _this.dlgPwdUpdateVisible = true;
        setTimeout(()=>{
          _this.$refs.pwdUpdate.onShow(null);
        },300);
      },
      onPwdUpdateClose() {
        this.dlgPwdUpdateVisible = false;
      },
      savePwd() {
        const _this = this;
        _this.$refs.pwdUpdate.saveData();
      },
      afterPwdSaved() {
        this.dlgPwdUpdateVisible = false;
        this.doLogout();
      },
      beforeunloadHandler(e){
        this.beforeUnloadTime = new Date().getTime();
      },
      unloadHandler(e){
        let timeSpan = new Date().getTime()-this.beforeUnloadTime;
        if(timeSpan < 3){
          resetLocalCache();
        }
      }
    },
    watch: {},
    mounted() {
      const _this = this;
      _this.containerHeight = window.innerHeight - $('#header').outerHeight();
      window.onresize = function windowResize() {
        _this.containerHeight = window.innerHeight - $('#header').outerHeight();
        _this.$refs.routerMain.onresize();
      };
    },
    destroyed(){
      const _this = this;
      window.removeEventListener('beforeunload', e => _this.beforeunloadHandler(e));
      window.removeEventListener('unload', e => _this.unloadHandler(e));
    },
    created() {
      window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
      window.addEventListener('unload', e => this.unloadHandler(e))
    }
  }
</script>

<style scoped lang="scss">
  .head-nav {
    width: 100%;
    min-width: 600px;
    padding: 0px;
    // background-color: #17a2b8 !important;
    background: linear-gradient(90deg, #bee0ee, #17a2b8);
    color: #333;
    text-align: center;
  }

  .head-log {
    padding: 0 20px;
    line-height: 80px;

  img {
    display: inline-block;
    vertical-align: middle;

  }

  .logonKm {

  img {
    width: 68px;
    height: 68px;
  }

  }
  .logonNHFY {

    img {
      width: 68px;
      height: 68px;
    }
  }
  .logonSFY {

    img {
      width: 68px;
      height: 68px;
    }
  }
  .title {
    float: left;
    line-height: 40px;
    padding-left: 20px;

  div {
    height: 40px;
    text-align: left;
    color: white;
  }

  .title-main {
    font-size: 16px;
    font-weight: bold;
  }

  .title-sub {
    height: 30px;
    line-height: 30px;
  }

  }
  }
  .nav-header {
    float: right;
    height: 100%;
    background: transparent;
    padding: 0px;
    margin: 0px;
    /*color: #fff;*/
    text-align: center;

  li {
    margin: 0px 8px;
    float: left;
    list-style: none;
    position: relative;

  img {
    display: inline-block;
    /*vertical-align: middle;*/
    cursor: pointer;
    padding-top: 10px;
    width: 40px;
    height: 40px;
  }

  }
  .userinfo-inner {
    cursor: pointer;

  img {

    border-radius: 20px;
    /*margin: 10px 0px 0px 10px;*/
    /*float: right;*/
  }

  }
  }
  .nav-pic-title {
    color: #fff;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue